export const StringifyComparer = (x, y) => JSON.stringify(x) === JSON.stringify(y);
